import type { RuntimeModel } from './modelCatalog';
/** Never fall back to the user's unrelated GM/chat model for prompt drafting. */
export function imagePromptModel(models: RuntimeModel[]): RuntimeModel | undefined {
  const eligible = models.filter(model => model.available && /deepseek-v4-flash/i.test(model.id) && !/reason/i.test(model.id));
  return eligible.find(model => /0723/.test(model.id)) || eligible.find(model => /0731/.test(model.id));
}
